import React, { Suspense } from "react";
import { useTranslation } from "react-i18next";

import { HvDialog } from "@hitachivantara/uikit-react-core";
import Loading from "components/layout/Loading";
import useStyles from "./styles";

import IncidentDialogContent, {
  IncidentDialogContentProps,
} from "./IncidentDialogContent";

export interface IncidentDialogProps extends IncidentDialogContentProps {
  isOpen: boolean;
  selectedEventTypeId?: string;
}

const IncidentDialog: React.FC<IncidentDialogProps> = ({
  isOpen,
  onCancel,
  onApply,
  actionType,
  initialValues,
  selectedEventTypeId,
}) => {
  const classes = useStyles();

  const { t } = useTranslation("incidentDialog");

  const onCloseHandler = (
    event: unknown,
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    if (reason !== "backdropClick") {
      onCancel?.();
    }
  };

  return (
    <HvDialog
      buttonTitle={t("buttons.close")}
      classes={{ paper: classes.paper }}
      open={isOpen}
      onClose={onCloseHandler}
      fullWidth
      maxWidth="md"
    >
      <Suspense
        fallback={
          <Loading
            delay={1000}
            loadingLabel=""
            className={classes.dialogContent}
          />
        }
      >
        {isOpen && (
          // this separation is merely for enclosing the api calls in the dialog's <Suspense>, rather than the page's
          <IncidentDialogContent
            onCancel={onCancel}
            onApply={onApply}
            actionType={actionType}
            initialValues={initialValues}
            selectedEventTypeId={selectedEventTypeId}
          />
        )}
      </Suspense>
    </HvDialog>
  );
};

export default IncidentDialog;
